import axios from "axios";
import routes from "@/common/routes";

export function post(url, data = {}, headers = {}) {
    return axios.post(routes.baseUrl+url, data, headers)
}

export function get(url, headers = {}) {
    return axios.get(routes.baseUrl+url, {headers:headers})
}